import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TraceContentDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    content: {
        flexDirection: "column",
        minWidth: 0
    },
    container: {
        alignSelf: "stretch",
        minWidth: 0
    },
    guide: {
        position: "absolute",
        top: 0
    }
});

export const useStyles = ({
    iconSizes,
    borders,
    colors,
    spaces
}: TraceContentDynamicStyleType) => {
    const styles = {
        content: {
            paddingStart: iconSizes.small + spaces.spacingSm,
            paddingBottom: spaces.spacingSm,
            paddingTop: spaces.spacingXs,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        guide: {
            start: (iconSizes.small - borders.separator) / 2,
            backgroundColor: colors.content.border.subtle,
            bottom: spaces.spacingSm,
            width: borders.separator
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
